import { GET_MERGED_STATEMENT_VIEWS } from './getMergedStatementViews';

import { GET_TRQK_STATEMENT_VIEW_AUTHENTICATED } from './getTrqkStatementViewAuthenticated';

import {
    getTrqkStatementView,
    GET_TRQK_STATEMENT_VIEW,
} from './getTrqkStatementView';

import { handleProIngestion, HANDLE_PRO_INGESTION } from './handleProIngestion';

import { ingestProStatement, INGEST_PRO_STATEMENT } from './ingestProStatement';

import {
    ingestProStatementV2,
    INGEST_PRO_STATEMENT_V2,
} from './ingestProStatementV2';

import {
    normalizeProStatement,
    NORMALIZE_PRO_STATEMENT,
} from './normalizeProStatement';

import {
    proIngestion,
    GET_PRO_INGESTION,
    GET_PRO_INGESTIONS,
} from './proIngestion';

export const proQueries = {
    proIngestion,
};

export const proMutations = {
    getTrqkStatementView,
    handleProIngestion,
    ingestProStatement,
    ingestProStatementV2,
    normalizeProStatement,
};

export const proQueryStrings = {
    GET_MERGED_STATEMENT_VIEWS,
    GET_PRO_INGESTION,
    GET_PRO_INGESTIONS,
    GET_TRQK_STATEMENT_VIEW_AUTHENTICATED,
    GET_TRQK_STATEMENT_VIEW,
    HANDLE_PRO_INGESTION,
    INGEST_PRO_STATEMENT_V2,
    INGEST_PRO_STATEMENT,
    NORMALIZE_PRO_STATEMENT,
};
